import React from 'react';
import Moment from 'moment';
import _slideLoader from '../../utilities/slideLoader';

export const SubcontractorsTableContents = ({
  vw,
  contents,
  infinityScrollLoad,
}) => (
  <div className='gate-schedulelist__list'>
    <table className='table'>
      <thead className='table__header'>
        <tr className='table__label'>
          <td
            id='labor-safety-table--date'
            className='labor-safety-table labor-safety-table--table__label'
          >
            <div className='labor-safety-table__label'>ステータス</div>
          </td>
          <td
            id='labor-safety-table--id'
            className='labor-safety-table labor-safety-table--table__label'
          >
            <div className='labor-safety-table__label'>協力会社名</div>
          </td>
          <td
            id='labor-safety-table--delivery-company'
            className='labor-safety-table labor-safety-table--table__label'
          >
            <div className='labor-safety-table__label'>職種</div>
          </td>
          <td
            id='labor-safety-table--constructor'
            className='labor-safety-table labor-safety-table--table__label'
          >
            <div className='labor-safety-table__label'>最終更新日</div>
          </td>
          <td className='labor-safety-table__flex-auto' />
        </tr>
      </thead>
      <tbody id='group1' className='table__group show'>
        {contents.map((content, index) => {
          return <Content key={index} content={content} vw={vw} />;
        })}
      </tbody>
    </table>
    {infinityScrollLoad}
  </div>
);

const Content = ({ content, vw }) => (
  <tr
    className='labor-safety-table__item'
    onClick={() =>
      _slideLoader.show(
        'SubcontractReNotifyDetail',
        {
          state: {
            id: `${content.field_id},${content.field_tree_id}`,
          },
        },
        vw
      )
    }
  >
    <td className='labor-safety-table conf-font-size'>
      <div className='value-table__status　conf-value-table-status'>
        {contentStatus(content)}
      </div>
    </td>
    <td className='labor-safety-table labor-safety-table--value'>
      <div className='labor-safety-table__txt--10'>{content.company_name}</div>
    </td>
    <td className='labor-safety-table conf-font-size'>
      <div className='labor-safety-table__txt--10'>{content.job_names}</div>
    </td>
    <td className='labor-safety-table labor-safety-table--value conf-font-size'>
      <div className='labor-safety-table__txt--4'>
        {Moment(content.updated_at).format('YYYY/MM/DD')}
      </div>
    </td>
    <td />
  </tr>
);

const contentStatus = content => {
  switch (content.status) {
    case 0:
      return (
        <button className='status-ticket--outline--large conf-status-ticket'>
          未提出
        </button>
      );
    case 1:
      return (
        <button className='status-ticket--caution--large conf-status-ticket'>
          未承認
        </button>
      );
    case 2:
      return (
        <button className='status-ticket--large conf-status-ticket'>
          承認済
        </button>
      );
    default:
      return (
        <button className='status-ticket--outline--large conf-status-ticket'>
          未提出
        </button>
      );
  }
};



// WEBPACK FOOTER //
// ./src/components/tables/SubcontractorsTable.jsx